export default __webpack_public_path__ + "static/media/etacOngleThumbnail.f08e3b02.jpg";